import RecordDisplay from './RecordDisplay'
import RecordForm from './RecordForm.container'
import IconRecord from 'components/Icons/Record'

export default {
  id: 'record',
  label: 'Record Voicemail',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/record-voicemail',
  icon: IconRecord,
  inputs: [{}],
  outputs: [],
  display: RecordDisplay,
  form: RecordForm,
  getPriceId: () => 'recordCall',
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Record/index.js